'use client';

import styles from './burgerMenu.module.scss';

interface BurgerMenuProps {
  isOpen: boolean;
  onClick: () => void;
}

export const BurgerMenu = ({ isOpen, onClick }: BurgerMenuProps) => {
  const lineStyles = `${styles.line} ${isOpen ? styles.isOpen : styles.isClose}`;

  return (
    <button
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      type="button"
      className={styles.menu}
      onClick={onClick}
    >
      <span className={lineStyles} />
      <span className={lineStyles} />
    </button>
  );
};
